module.exports = __webpack_public_path__ + "static/media/icon-shout.752161d1.svg";